import React from "react";
import dayjs from "dayjs";

const STATUS_STYLE = {
  "new":         "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
  "in progress": "text-blue-400 bg-blue-500/10 border-blue-500/20",
  "waiting":     "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  "resolved":    "text-white/30 bg-white/5 border-white/10",
  "closed":      "text-white/20 bg-white/5 border-white/5",
};

const PRIORITY_STYLE = {
  p1: "text-red-400 bg-red-500/10 border-red-500/20",
  p2: "text-orange-400 bg-orange-500/10 border-orange-500/20",
  p3: "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  p4: "text-white/30 bg-white/5 border-white/10",
};

const SLA_STYLE = {
  OK:       "text-[#00ff90]/60 bg-[#00ff90]/5 border-[#00ff90]/15",
  AT_RISK:  "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  BREACHED: "text-red-400 bg-red-500/10 border-red-500/20",
};

export default function TeamTicketList({ loading, rows, onRowClick }) {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, i) => <div key={i} className="h-12 rounded-lg bg-white/5 animate-pulse" />)}
      </div>
    );
  }

  if (!rows?.length) {
    return <p className="text-white/30 text-sm py-4 text-center italic">No tickets found.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-white/5">
            {["ID","Title","Requester","Assignee","Priority","Status","SLA","Updated",""].map(h => (
              <th key={h} className="px-3 py-3 text-left text-xs text-[#00ff90]/40 uppercase tracking-wider font-medium whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(t => {
            const statusKey   = (t.status   || "").toLowerCase();
            const priorityKey = (t.priority || "").toLowerCase().split(" ")[0];
            const slaKey      = t.sla || "OK";
            return (
              <tr key={t.id} className="border-b border-white/5 hover:bg-white/3 transition-colors">
                <td className="px-3 py-3 text-white/30 text-xs font-mono">{t.id}</td>
                <td className="px-3 py-3">
                  <button onClick={() => onRowClick?.(t)} className="text-left text-white/80 hover:text-[#00ff90] transition-colors text-sm max-w-[180px] truncate block">
                    {t.title}
                  </button>
                </td>
                <td className="px-3 py-3 text-white/50 text-xs">{t.requester}</td>
                <td className="px-3 py-3 text-white/40 text-xs">{t.assignee || "—"}</td>
                <td className="px-3 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full border ${PRIORITY_STYLE[priorityKey] || "text-white/30 bg-white/5 border-white/10"}`}>
                    {t.priority}
                  </span>
                </td>
                <td className="px-3 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full border capitalize ${STATUS_STYLE[statusKey] || "text-white/30 bg-white/5 border-white/10"}`}>
                    {t.status}
                  </span>
                </td>
                <td className="px-3 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full border ${SLA_STYLE[slaKey] || SLA_STYLE.OK}`}>
                    {slaKey === "AT_RISK" ? "At Risk" : slaKey === "BREACHED" ? "Breached" : "OK"}
                  </span>
                </td>
                <td className="px-3 py-3 text-white/25 text-xs whitespace-nowrap">
                  {t.updated ? dayjs(t.updated).format("DD MMM HH:mm") : "—"}
                </td>
                <td className="px-3 py-3">
                  <button onClick={() => onRowClick?.(t)}
                    className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/20 bg-[#00ff90]/5 text-[#00ff90]/60 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
                    Open
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}